const scrollToTop = () => {
    document.documentElement.scrollTo({
        top: 0,
        behavior: "auto",
    });
}

export default scrollToTop;